"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PRODUCT_LAYOUTS = [
    'default',
    'defaultReduced',
    'defaultBigPicture',
    'moreInfo',
    'justImage',
    'justProductName',
];
exports.default = PRODUCT_LAYOUTS;
//# sourceMappingURL=productLayouts.js.map